// ValidationModal.js
import React from "react";

const ValidationModal = ({ show, onClose, errors }) => {
  if (!show || !errors.length) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6  rounded shadow-xl  ">
      <div className=" w-full max-w-3xl overflow-y-auto max-h-[70vh]">
        <h2 className="text-xl font-semibold text-red-600 mb-4">Validation Errors</h2>
        
        <table className="min-w-full text-sm text-left border border-gray-300">
          <thead>
            <tr className="bg-gray-100 text-gray-700">
              <th className="border px-4 py-2">Row</th>
              <th className="border px-4 py-2">Field</th>
              <th className="border px-4 py-2">Error Message</th>
            </tr>
          </thead>
          <tbody>
            {errors.map((error, index) => (
              <tr key={index}>
                <td className="border px-4 py-2">{error.row}</td>
                <td className="border px-4 py-2">{error.field}</td>
                <td className="border px-4 py-2 text-red-500">{error.message}</td>
              </tr>
            ))}
          </tbody>
        </table>


      </div>
      <div className="mt-5 text-right">
          <button
            onClick={onClose}
            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ValidationModal;
